import { Box } from "@chakra-ui/react";
import React from "react";
import Projects from "../Components/Projects";

const ProjectsPage = () => {
  return (
    <Box
      as="main"
      w="full"
      h="full"
      pos="relative"
      boxSizing="border-box"
      my="8"
      px="8"
    >
      <Projects />
    </Box>
  );
};

export default ProjectsPage;
